import React, { useContext, useState } from "react";
import Exit from "../../assets/icons/exit.png";
import styled from "styled-components";
import { AuthContext } from '../../../../Contexts/auth';
import "./Profile.css"
import { useChatbot } from '../../../../Contexts/ChatbotContext';

const Name = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 15px 0px 0px;
  color: white;
`;

const Logout = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  margin: 0px 15px 0px 0px;
  img {
    width: 100%;
  }
`;

const Profile = () => {
  const { logout, user } = useContext(AuthContext);
  const { isModalOpen, setIsModalOpen } = useChatbot();

  const handleLogout = () => {
    logout();
  };

  const toggleChatbot = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="header-profile">


      <Logout>
        <img id="exit-image" src={Exit} alt="logout" onClick={handleLogout} />
      </Logout>

    </div>
  );
};

export default Profile;
